import { currentI18n } from "./i18n"

class TogglePasswordView
{
    constructor(element)
    {
        this._type = "password";
        this._icon = "eye";
        this._title = "show";
        this._displayed = true;

        this.element = element;
        this.button = this.element.querySelector(".toggle-password-view-button");
        this.icon = this.element.querySelector(".toggle-password-view-button i");
        this.input = this.element.querySelector("input[type=password]");
    }

    connectListener()
    {
        this.button.addEventListener('click', () => {
            this.togglePasswordView();
        });
        this.input.addEventListener('change', () => {
            this.button.disabled = this.input.disabled;
        });

        this.updateElements();
    }

    togglePasswordView()
    {
        this._displayed = !this._displayed;

        this._title = this._displayed ? "show" : "hide";
        this._icon = this._displayed ? "eye" : "eye-off";
        this._type = this._displayed ? "password" : "text";

        this.updateElements();
    }

    updateElements()
    {
        const i18n = currentI18n();
        this.button.setAttribute("title", i18n.t("common:password.toggle." + this._title));
        this.icon.setAttribute("class", "nf nf-" + this._icon)
        this.input.setAttribute("type", this._type);
    }
}

export const password = {
    init: function() {
        document.querySelectorAll('.toggle-password-view').forEach(function(element) {
            const passwordField = new TogglePasswordView(element);

            passwordField.connectListener();
        });
    }
}
